import 'babel-polyfill';
import  promise from 'es6-promise';
promise.polyfill();
import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import ElementUI from 'element-ui';
import axios from 'axios';
Vue.prototype.$http=axios;


import util from'./assets/js/util';
import md5 from './assets/js/md5';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/js/rem.js';



// import 'assets/css/iconfont/iconfont.css'
// import theConfirm from 'assets/js/alertConfirm.js'

Vue.use(ElementUI);
Vue.prototype.$md5=md5;
Vue.config.productionTip = false;


Vue.prototype.$util=util;
axios.defaults.baseURL = '/api';
axios.defaults.headers.post['Content-Type'] = 'application/json';

axios.interceptors.request.use(function (config) {
    var token=sessionStorage.getItem('token');
    if(token&&token.length>0){
        config.headers.Authorization=token;
        config.headers.token=token;
    }else{
        config.headers.Authorization='';
        config.headers.token=token;
    }
    return config;
}, function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
});
var myInterceptor = axios.interceptors.response.use(function (response) {
    var response=response;
    if(!response.data){
        return response;
    }
    var data=response.data;
    if(data.code=='411'||data.code=='900'||data.code=='901'||data.code=='902'||data.code=='903'||data.code=='905'){
        //退出登录并跳转登录页面
        sessionStorage.setItem('logined','0')
        sessionStorage.setItem('userId','')
        // sessionStorage.setItem('token','')
        router.replace('/login');
    }
    // return response.data;
    return response;
}, function (error) {
    //     200
//     服务器成功返回用户请求的数据！
// 成功
//     410
//     提示信息：无此模块
//     失败
//     411
//     提示信息：用户信息错误
//     失败
//     900
//     超时强制下线
//     失败
//     902
//     token认证过期
//     失败
//     903
//     token认证失败
    var response=error.response;
    var data;
    if(!response.data){
        return;
    }
    data=response.data;
    if(data.code=='411'||data.code=='900'||data.code=='901'||data.code=='902'||data.code=='903'||data.code=='905'){
        //退出登录并跳转登录页面
        sessionStorage.setItem('logined','0')
        sessionStorage.setItem('userId','')
        sessionStorage.setItem('token','')
        // Elementui.Message.error(data.msg);
        router.replace('/login');
    }
    // 对响应错误做点什么
    return Promise.reject(error);
});

new Vue({
  el:"#app",
  router,
  store,
  render: h => h(App)
}).$mount('#app');
